export default __webpack_public_path__ + "static/media/trash.f860584b.svg";